import Reveal from "../Reveal";
import React from "react";

const stats = [
  { label: "Active users", value: "25K+" },
  { label: "Countries", value: "40+" },
  { label: "Uptime", value: "99.9%" },
];

const challenges = [
  "Pelanggan yang ingin dilayani lebih cepat",
  "Persaingan yang semakin ketat",
  "Biaya operasional yang terus meningkat",
  "Data yang semakin banyak, aset yang semakin kompleks",
  "Tuntutan mengambil keputusan berdasarkan data",
];

const technologies = [
  "Artificial Intelligence",
  "IoT",
  "Software",
  "Automation",
  "Energy Technology",
  "Robotics",
];


export default function AboutUs() {
  return (
    <>
      <section id="about" className="section">
        <div className="mx-auto max-w-7xl px-6 lg:px-16">

          {/* Section Label */}
          <div className="mb-7 flex items-center gap-4">
            <span className="font-mono text-[11px] tracking-[0.25em] text-cyan-300">
              01
            </span>

            <span className="h-px w-8 bg-orange-400/70" />

            <span className="font-mono text-[11px] tracking-[0.25em] text-slate-400">
              LATAR BELAKANG
            </span>
          </div>

          {/* Heading */}
          <div className="max-w-3xl">
            <h2 className="text-4xl font-medium leading-[1.3] tracking-tight text-slate-100 md:text-5xl lg:text-[44px]">
              Dunia bisnis sedang berubah
              <br />
              <span className="text-slate-100">
                besar-besaran.
              </span>
            </h2>

            <p className="mt-7 max-w-2xl text-sm leading-7 text-slate-400 md:text-[15px]">
              Dulu, perusahaan cukup mengandalkan manusia, komputer, dan proses
              kerja manual.
              <br className="hidden md:block" />
              Hari ini, tekanannya jauh lebih besar.
            </p>
          </div>

          {/* Main Content */}
          <div className="mt-16 grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">

            {/* LEFT — Challenges */}
            <div>
              {challenges.map((item, index) => (
                <div
                  key={index}
                  className="
                    group
                    flex
                    min-h-[55px]
                    items-center
                    border-b
                    border-slate-800
                    transition-colors
                    duration-300
                    hover:border-slate-700
                  "
                >
                  {/* Orange dash */}
                  <span
                    className="
                      mr-4
                      h-px
                      w-2
                      shrink-0
                      bg-orange-400
                      transition-all
                      duration-300
                      group-hover:w-4
                    "
                  />

                  <span
                    className="
                      text-sm
                      text-slate-200
                      transition-colors
                      duration-300
                      group-hover:text-white
                    "
                  >
                    {item}
                  </span>
                </div>
              ))}
            </div>

            {/* RIGHT */}
            <div className="flex flex-col">

              {/* Description */}
              <p className="max-w-xl text-sm leading-6 text-slate-400">
                Teknologi untuk menjawabnya sebenarnya sudah tersedia —
                masalahnya, bagi banyak perusahaan, teknologi ini masih berdiri
                sendiri-sendiri.
              </p>

              {/* Technology Tags */}
              <div className="mt-4 flex flex-wrap gap-2.5">
                {technologies.map((technology) => (
                  <span
                    key={technology}
                    className="
                      border
                      border-slate-700
                      bg-[#0b1116]
                      px-3.5
                      py-2
                      font-mono
                      text-[11px]
                      text-slate-400
                      transition-all
                      duration-300
                      hover:border-cyan-400/50
                      hover:bg-cyan-400/5
                      hover:text-cyan-300
                    "
                  >
                    {technology}
                  </span>
                ))}
              </div>

              {/* Statement Box */}
              <div
                className="
                  relative
                  mt-10
                  overflow-hidden
                  border-l-2
                  border-cyan-400
                  bg-[#111821]
                  px-7
                  py-7
                "
              >
                {/* subtle glow */}
                <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-cyan-400/5 blur-3xl" />

                <p className="relative max-w-md font-semibold leading-7 text-white">
                  Di sinilah{" "}
                  <span className="text-white">WINREVO</span> hadir —
                  menghubungkan semuanya menjadi satu ekosistem.
                </p>
              </div>

            </div>
          </div>

        </div>
      </section>
      <section className="relative overflow-hidden bg-[#090f13] py-24 md:py-28 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-16">          
          {/* Label */}
          <div className="mb-7 flex items-center gap-4">
            <span className="font-mono text-[11px] tracking-[0.25em] text-cyan-300">
              02
            </span>

            <span className="h-px w-8 bg-orange-400/70" />

            <span className="font-mono text-[11px] tracking-[0.25em] text-slate-400">
              APA ITU WINREVO?
            </span>
          </div>

          {/* Heading */}
          <h2 className="text-4xl font-medium leading-[1.3] tracking-tight text-slate-100 md:text-5xl lg:text-[44px]">
            Technology Holding Company.
          </h2>

          {/* Description */}
          <div className="mt-12 text-lg leading-[1.55]">
            <p>
              <span className="font-semibold text-[#18ddd0]">
                WINREVO adalah perusahaan yang membantu bisnis dan industri
                menggunakan teknologi untuk bekerja lebih cepat, lebih efisien,
                lebih pintar, dan lebih menguntungkan.
              </span>{" "}
              <span className="text-[#e5e8eb]">
                Bukan menjual satu jenis teknologi — WINREVO membangun berbagai
                solusi teknologi yang saling terhubung.
              </span>
            </p>
          </div>

          {/* Technology Flow */}
          <div className="mt-9 flex flex-wrap items-center gap-y-2">
            {technologies.map((technology, index) => (
              <React.Fragment key={technology}>
                <div
                  className={`
                    border border-[#34404b]
                    bg-[#0c1218]
                    px-3.5 py-2.5
                    font-mono text-md
                    text-[#d6e1eb]
                    transition-all duration-200
                    hover:border-cyan-400
                    hover:text-cyan-300
                    ${technology === "Automation"
                      ? "hover:bg-[#0c1218]"
                      : ""}
                  `}
                >
                  {technology}
                </div>

                {index < technologies.length - 1 && (
                  <span className="mx-3 font-mono text-[10px] text-[#668096]">
                    ↓
                  </span>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* Bottom Statement */}
          <p className="mt-7 text-[14px] font-medium text-gradient">
            Mengubah teknologi menjadi hasil nyata bagi bisnis.
          </p>
        </div>
      </section>
    </>
  );
}
